import { StateInterface } from "./state";
import { Type } from "../models/message";

export default {
  open(state: StateInterface, type: Type): void {
    state.visible = true;
    state.type = type;
  },
  close(state: StateInterface): void {
    state.visible = false;
    state.type = "";
  }
};
